import { API_TIMEOUT_TIERS } from '#pplx/frontend/api-clients/core/utils.js';
import { connectorsClient } from '#pplx_generated/typespec/rest/connectors/client.js';
import { sseClient } from '#pplx_generated/typespec/rest/sse/client.js';
import { uploadsClient } from '#pplx_generated/typespec/rest/uploads/client.js';
export const createUploadUrl = async ({ file, fileSource = 'default', forceImage = false, reason, skipParsing = false, headers, }) => {
    const resp = await uploadsClient.POST('/rest/uploads/create_upload_url', reason, {
        body: {
            filename: file.name,
            content_type: file.type,
            source: fileSource,
            file_size: file.size,
            force_image: forceImage,
            skip_parsing: skipParsing,
        },
        timeoutMs: API_TIMEOUT_TIERS.MEDIUM,
        retries: 2,
        headers,
    });
    if (resp.data) {
        return resp.data;
    }
    return null;
};
export const batchCreateUploadUrls = async ({ filesWithUuids, fileSource = 'default', forceImage = false, reason, skipParsing = false, headers, }) => {
    // Schema types are read-only, so we need to create a mutable copy of the type here so we can populate files
    const files = {};
    filesWithUuids.forEach(({ uuid, file }) => {
        files[uuid] = {
            filename: file.name,
            content_type: file.type,
            source: fileSource,
            file_size: file.size,
            force_image: forceImage,
            skip_parsing: skipParsing,
        };
    });
    const resp = await uploadsClient.POST('/rest/uploads/batch_create_upload_urls', reason, {
        body: {
            files,
        },
        timeoutMs: API_TIMEOUT_TIERS.MEDIUM,
        retries: 2,
        headers,
    });
    if (resp.data) {
        return resp.data.results;
    }
    return null;
};
export const uploadConnectorsAttachment = async ({ remote_file_id, connection_type, source, reason, headers, analytics, }) => {
    const resp = await connectorsClient.POST('/rest/connectors/attachments/upload', reason, {
        body: {
            remote_file_id: remote_file_id,
            connection_type: connection_type,
            source: source ?? 'default',
            analytics_metadata: analytics
                ? { upload_attempt_id: analytics.uploadAttemptUUID }
                : undefined,
        },
        timeoutMs: API_TIMEOUT_TIERS.VERY_HIGH,
        retries: 2,
        headers,
    });
    const response = resp.data;
    return {
        response: response ?? null,
        errorCode: response?.error_code ?? (resp.error ? 'client_no_response' : null),
    };
};
export async function subscribeAttachments({ request, reason, headers, }) {
    return new Promise((resolve, reject) => {
        sseClient
            .SSE('/rest/sse/attachment_processing/subscribe', reason, {
            params: request,
            headers,
            handlers: {
                message: (data) => {
                    resolve(data);
                },
            },
        })
            .catch(reject);
    });
}
export function subscribeAttachmentsBatch({ request, reason, onMessage, headers, }) {
    return sseClient.SSE('/rest/sse/attachment_processing/subscribe', reason, {
        params: request,
        headers,
        handlers: {
            message: onMessage,
        },
    });
}
//# sourceMappingURL=attachments.js.map